import $ from 'jquery';
import ScrollMagic from "ScrollMagic";
import 'debug.addIndicators';
import 'animation.gsap';
import { Power1, Power0, Power4, Linear, TweenMax } from "gsap/TweenMax";

export default () => {
    $(document).ready(function () {
        [].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
            img.setAttribute('src', img.getAttribute('data-src'));
            img.onload = function () {
                //console.log(img.getAttribute('data-src') + ' loaded');
                img.removeAttribute('data-src');
            };
        });
    });
};



// WEBPACK FOOTER //
// ./scripts/libs/lazy-load.js